import { Component, OnInit } from '@angular/core';
import { topicMaster } from '../../../Models/TopicMasterModel';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AdminTopicMasterServices } from '../../../Services/Admin/TopicMaster';
import { CheckAuth } from '../../../Services/UtilityService';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-manage-topic',
  templateUrl: './manage-topic.component.html',
  styleUrls: ['./manage-topic.component.css']
})
export class ManageTopicComponent implements OnInit {
  tokenKey: string = '';
  topicMaster = new topicMaster();
  statusCode: number = 0;
  insertedTopicID: number = 0;
  buttonText: string = '';
  updateDeleteID: string = '';
  loginUserID: string = '1';

  topicForm = new FormGroup({
    topicId: new FormControl(''),
    topicName: new FormControl('', Validators.required),
    // isActive: new FormControl('Active', Validators.required),
    isActive: new FormControl('true', Validators.required),
    displayOrder: new FormControl(''),
    totalRecords: new FormControl('')
  });

  constructor(private toastr: ToastrService,private checkAuth: CheckAuth, private topicService: AdminTopicMasterServices, private router: Router, private activedRoute: ActivatedRoute) {
    this.topicMaster.isActive = "true"
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.buttonText = 'Save';
    this.activedRoute.params.subscribe((params: Params) => {
      this.updateDeleteID = params['id'];
      // Bind Edit Data 
      if (this.updateDeleteID != null) {
        this.getTopic(this.updateDeleteID);
        this.buttonText = "Update";
      }
    });
  }

  setOprationSession(AddEdit: string) {
    sessionStorage.setItem('TopicCRUDStatus', AddEdit);
  }

  getTopic(topicId: string) {
    debugger;
    if (topicId != null) {
      this.topicService.GetSingleTopicMaster(this.tokenKey, topicId)
        .subscribe(data => {
          debugger;
          this.topicMaster = data["topic"][0];
          this.topicForm.setValue({
            'topicName': this.topicMaster.topicName,
            'topicId': this.topicMaster.topicId,
            //'isActive': this.inductryMaster.isActive ? 'Active' : 'Deactive',            
            'isActive': this.topicMaster.isActive,
            'displayOrder': this.topicMaster.displayOrder,
            'totalRecords': this.topicMaster.totalRecords
          });
        },
          error => this.statusCode = error);
    }
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  saveTopic(topicForm: NgForm) {
    this.topicMaster = topicForm.value;

    if (topicForm.value["topicName"] == "" || topicForm.value["topicName"] == null || topicForm.value["topicName"] == undefined) {
      this.showMessage('Please enter topic name', 'Error', 'error');
      return;
    }

    debugger;
    if (this.topicMaster != null) {
      if (parseInt(this.topicMaster.topicId) > 0) {
        this.topicService.AddUpdateTopicMaster(this.tokenKey, topicForm.value["topicName"], topicForm.value["isActive"], this.updateDeleteID, this.loginUserID)
          .subscribe(topicId => {
            debugger;
            this.insertedTopicID == topicId["topicID"]
            this.setOprationSession('Edited');
            this.router.navigate(['/admin/topic']);
          },
            error => this.statusCode = error);
      }
      else {
        this.topicService.AddUpdateTopicMaster(this.tokenKey, topicForm.value["topicName"], topicForm.value["isActive"], 'null', this.loginUserID)
          .subscribe(topicId => {
            debugger;
            this.insertedTopicID == topicId["topicID"]
            this.setOprationSession('Added');
            this.router.navigate(['/admin/topic']);
          },
            error => this.statusCode = error);
      }
    }
  }

  returnToTopicList() {
    this.router.navigate(['/admin/topic']);
  }
}
